import {ReactNode} from 'react';
import {PostHogErrorBoundary, PostHogProvider} from '@posthog/react';
import {PageLoadErrorFallback} from '@common/errors/page-load-error-fallback';
import {createPostHogOptions} from './posthog-options';

interface PostHogMonitoringProviderProps {
  projectToken: string;
  host?: string;
  children: ReactNode;
}

// rendered outside every app provider, so it must stay context-free
function PostHogErrorFallback() {
  return <PageLoadErrorFallback />;
}

export function PostHogMonitoringProvider({
  projectToken,
  host,
  children,
}: PostHogMonitoringProviderProps) {
  return (
    <PostHogProvider
      apiKey={projectToken}
      options={createPostHogOptions(host)}
    >
      <PostHogErrorBoundary fallback={PostHogErrorFallback}>
        {children}
      </PostHogErrorBoundary>
    </PostHogProvider>
  );
}
